





























import {Component, Vue} from 'vue-property-decorator'
import ListSorter from "@/components/ListSorter/ListSorter.vue";
import MenuOptionSelector from "@/components/OptionSelector/MenuOptionSelector.vue";
import CategoryOptionSelector from "@/components/OptionSelector/CategoryOptionSelector.vue";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";

@Component({
    components: {
        ListSorter,
        MenuOptionSelector,
        CategoryOptionSelector,
    },
})

export default class CategoryListSorter extends Vue {

    get categoryIds(): number[] {
        return CategoriesStore.all.map(v => v.id);
    }

    private category(categoryId: number): CMS.Category {
        return CategoriesStore.categoryById[categoryId] || {}
    }

}

